import { TableV2 } from '@anytag/shared-atoms';
import { PostDetailsType, TableData } from '@anytag/shared-types';
import { InfluencerYoutubeAnalyticsPostDetailsModal } from '@anytag/shared-molecules';
import { useAnalyticsYoutubeCompareVideosListTable } from './hooks';
import { AnalyticsYoutubeCompareVideosType } from './types';

export interface AnalyticsYoutubeCompareVideosListProps extends TableData<AnalyticsYoutubeCompareVideosType> {
  mainSocialAccountId?: number | null;
}

export const AnalyticsYoutubeCompareVideosList = ({
  loading,
  data = [],
  mainSocialAccountId
}: AnalyticsYoutubeCompareVideosListProps) => {
  const { columns } = useAnalyticsYoutubeCompareVideosListTable();

  return (
    <>
      <TableV2 loading={loading} data={data} columns={columns} rowHeight="62px" noTopBorderRadius hasBorder />

      <InfluencerYoutubeAnalyticsPostDetailsModal
        posts={data.map(({ id }): PostDetailsType => ({ id: String(id), mainSocialAccountId }))}
        isAnalytics
      />
    </>
  );
};
